import { render, staticRenderFns } from "./DoubleHeader.vue?vue&type=template&id=1c644298&scoped=true"
import script from "./DoubleHeader.vue?vue&type=script&lang=ts"
export * from "./DoubleHeader.vue?vue&type=script&lang=ts"
import style0 from "./DoubleHeader.vue?vue&type=style&index=0&id=1c644298&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c644298",
  null
  
)

export default component.exports